import { render, staticRenderFns } from "./SetOtp.vue?vue&type=template&id=60354852&scoped=true&"
import script from "./SetOtp.vue?vue&type=script&lang=js&"
export * from "./SetOtp.vue?vue&type=script&lang=js&"
import style0 from "./SetOtp.vue?vue&type=style&index=0&id=60354852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60354852",
  null
  
)

export default component.exports